import React, { FunctionComponent, useState } from 'react';
import HashtagDetailsCharts from 'hashtags/components/HashtagDetails/HashtagDetailsCharts';
import {
  loadHashtagGrabbingStatus,
  loadHashtagView,
  changeTweetType,
} from 'hashtags/Requests';
import { useQuery } from 'react-query';
import Loader from 'app/components/Loader';
import { handelStatusError } from 'app/utils/helpers';
import { useModal } from 'app/context/Modal';
import DraggableTweetsColumns from 'app/components/DraggableTweetsColumns';
import { apiRoutes as hashtagsApiRoutes } from 'hashtags/utils/apiRoutes';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { getDefaultHashtagsIds } from 'reports/Requests';
import { Grid } from '@material-ui/core';
import styles from './HashtagSingle.module.scss';

interface Props {
  isTemplate?: boolean;
  isSample?: boolean;
  items?: any[];
  reportHashtag?: any;
  reportData?: any;
}
const formattedFilters = {};
const HashtagSingle: FunctionComponent<Props> = ({
  isTemplate,
  items,
  reportHashtag,
  reportData,
  isSample,
}) => {
  const { data: defaultHashtagsIds, isLoading: defaultHashtagsIdsLoading } =
    useQuery('defaultHashtagsIds', getDefaultHashtagsIds, {
      enabled: isTemplate && !reportHashtag,
    });
  const report = useReport() as any;
  const allPlatforms = [
    ...new Set(
      (report?.values?.charts || items)
        ?.map((item: any) => {
          return item?.slug?.includes('instagram')
            ? 'instagram'
            : item?.slug?.includes('linkedin')
              ? 'linkedin'
              : item?.slug?.includes('youtube')
                ? 'youtube'
                : item?.slug?.includes('tweets')
                  ? 'twitter'
                  : item?.slug?.includes('tiktok')
                    ? 'tiktok'
                    : '';
        })
        .filter((item: any) => item),
    ),
  ];
  const [statusApiError, setStatusApiError] = useState(false);
  const modal = useModal();
  const id =
    reportHashtag?.id ||
    (Array.isArray(report?.values?.items)
      ? +report?.values?.items?.[0]?.id
      : +report?.values?.items);

  const {
    isLoading,
    data: hashtag,
    isError: hashtagError,
  } = useQuery(
    [
      'loadHashtag',
      {
        hashtag_id: id,
        is_sample: isSample,
      },
    ],
    loadHashtagView,
    {
      enabled: !!id,
    },
  );

  const { isLoading: statusLoad, data: hashtagStatus } = useQuery(
    ['HashtagStatus', { hashtag_id: +id, is_sample: isSample }],
    loadHashtagGrabbingStatus,
    {
      enabled: !!id,
      refetchInterval: !statusApiError ? undefined : 120000,
      onSuccess: (data) => {
        data?.is_completed ? setStatusApiError(false) : setStatusApiError(true);
      },
      onError: (error) => {
        handelStatusError(error, modal.show);
      },
    },
  );
  if (isLoading || statusLoad || defaultHashtagsIdsLoading) return <Loader />;
  return (
    <>
      <HashtagDetailsCharts
        {...{
          formattedFilters,
          hashtag,
          id,
          reftechSentment: '',
          hashtagStatus,
          hashtagError,
          isReport: true,
          isTemplate,
          isSample,
          multiTabNames: allPlatforms,
        }}
        items={items || report?.values?.charts}
      />
      <Grid className={styles.draggableTweetCOlContainer} md={12}>
        <DraggableTweetsColumns
          tweetColumnFilters={{
            hashtag_id: +id,
            start_date: reportData?.start_date,
            end_date: reportData?.end_date,
          }}
          customFilters={{ hashtag_id: +id }}
          slugName={
            allPlatforms?.includes('instagram')
              ? hashtagsApiRoutes().hashtagInstaPosts
              : allPlatforms?.includes('youtube')
                ? hashtagsApiRoutes().hashtagVideos
                : allPlatforms?.includes('linkedin')
                  ? hashtagsApiRoutes().hashtagLinkedInPosts
                  : hashtagsApiRoutes().hashtagTweets
          }
          filters={{
            hashtag_id: +id,
            is_sample: isSample,
            start_date: reportData?.start_date,
            end_date: reportData?.end_date,
          }}
          analyzed={hashtag?.analyzed}
          action={changeTweetType}
          isKeyValueArr
          isMultiTweets
          hashtagDetails={hashtag}
          reftechSentmentHandler={() => {
            return undefined;
          }}
          setFilterIsLoading={() => {
            return undefined;
          }}
          tabName={
            allPlatforms?.includes('linkedin')
              ? 'TWEETS'
              : allPlatforms?.includes('youtube')
                ? 'VIDEOS'
                : allPlatforms?.includes('instagram') ||
                    allPlatforms?.includes('linkedin')
                  ? 'POSTS'
                  : ''
          }
          filterIsLoading={false}
          compId={
            allPlatforms?.includes('instagram')
              ? 'hashtags_hashtag_view_instagram'
              : allPlatforms?.includes('tiktok')
                ? 'hashtags_hashtag_view_tiktok_videos'
                : allPlatforms?.includes('linkedin')
                  ? 'hashtags_hashtag_view_linkedin'
                  : allPlatforms?.includes('youtube')
                    ? 'hashtags_hashtag_view_youtube'
                    : 'hashtags_hashtag_view'
          }
          hideSort
          isReport
          isTemplate={isTemplate}
          items={items}
          reportState={report}
        />
      </Grid>
    </>
  );
};

export default HashtagSingle;
